import { 
  LISTINGS_FILTERS_BLOCK_1,
 } from '@/constants'

export const LISTINGS_FILTERS = {
  filter_blocks: [
    LISTINGS_FILTERS_BLOCK_1,
  ]
}

// ─── Bulk end listings (CDP-2459) ───────────────────────────────────────────
//
// `VITE_API_HOST` already ends in `/api/v2`, so this path resolves to
// POST /api/v2/listings/end.
export const LISTINGS_END_ENDPOINT = '/listings/end'

// Client-side guardrail on how many items one bulk action may touch.
//
// The API accepts up to 500 card_ids per request; the design specifies 100 and
// a warning toast when exceeded. We enforce the DESIGN number because it's the
// customer-facing promise, and it's applied across the WHOLE selection (not per
// marketplace) so the count in the toast matches the count of checked rows.
// CDP-2459 open question #1 — flip this one constant if product says 500.
export const BULK_LISTING_SELECTION_LIMIT = 100

// Shown for End and List/Relist — both share `guardSelectionLimit`. Wording
// stays generic so Batch "all cards" (>100) and Inventory selection both read
// correctly whether the user was ending or publishing.
export const BULK_LISTING_LIMIT_MESSAGE =
  `You can't manage more than ${BULK_LISTING_SELECTION_LIMIT} listings at a time`

// Marketplaces the /listings/end contract accepts.
export const END_LISTING_MARKETPLACES = Object.freeze([
  'ebay',
  'ebay-direct',
  'collx',
  'whatnot',
  'shopify',
])

// How a selected item relates to a given marketplace. Drives which ids go into
// `card_ids` and which modal-breakdown line the item is counted on.
export const LISTING_ITEM_STATE = Object.freeze({
  ACTIVE: 'active',     // live listing → eligible to end
  ENDED: 'ended',       // previously listed, already ended → skipped
  UNLISTED: 'unlisted', // never listed → skipped
})

// Raw `listing.<marketplace>_status` values, projected onto card.<key>ListedStatus
// by InventoryStore / CardStore.
export const LISTED_STATUS = Object.freeze({
  LISTED: 'listed',
  ENDED: 'ended',
  INACTIVE: 'inactive',
})

export const PRODUCT_DETAILS_FIELDS = [
  {
    field: 'set',
    label: 'Set',
    type: 'text',
  },
  {
    field: 'team',
    label: 'Team',
    type: 'text',
  },
  {
    field: 'year',
    label: 'Year',
    type: 'number',
  },
  {
    field: 'brand',
    label: 'Brand',
    type: 'text',
  },
  {
    field: 'card_number',
    label: 'Card Number',
    type: 'number',
  },
  {
    field: 'player',
    label: 'Name',
    type: 'text',
  },
  {
    field: 'attributes',
    label: 'Attributes',
    type: 'text',
  },
  {
    field: 'sports',
    label: 'Category',
    type: 'text',
  },
  {
    field: 'subset',
    label: 'Subset / Parallel',
    type: 'text'
  },
  {
    field: 'variation',
    label: 'Variation',
    type: 'text',
  },
  {
    field: 'serial_number',
    label: 'Serial Number',
    type: 'text',
  },
]

export const LISTING_STATUS = {
  'accepting_offers': {
    key: 'accepting_offers',
    label: 'Accepting Offers',
    icon: 'heroicons:hand-money',
  },
  'for_sale': {
    key: 'for_sale',
    label: 'For Sale',
    icon: 'heroicons:tag',
  },
  'sold_out': {
    key: 'sold_out',
    label: 'Sold Out',
    icon: 'heroicons:tag',
  },
  'sold_on': {
    key: 'sold_on',
    label: 'Sold On',
    icon: 'heroicons:tag',
  },
  'ended': {
    key: 'ended',
    label: 'Ended',
    icon: 'heroicons:tag',
  },
}
